// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon--34yCD","Popover":"Popover--4ORFk"};